import React, { ReactElement } from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { SortButtons } from '../../../../shared/components/buttons';
import { scholasticCustomersListStore } from '../../../stores/ScholasticCustomersListStore';
import {
  SCHOLASTIC_CUSTOMER_COLUMN,
  ScholasticCustomerColumn,
} from '../NgzScholasticCustomerList.settings';

type TitleRowProps = {
  visibleColumns: ScholasticCustomerColumn[];
};

const TitleRow = observer(({ visibleColumns }: TitleRowProps) => {
  const { filterMethod } = scholasticCustomersListStore;
  const { handleSort, getIsSortedBy } = filterMethod;

  const renderColumnsInfo: Record<ScholasticCustomerColumn, ReactElement> = {
    [SCHOLASTIC_CUSTOMER_COLUMN.NAME]: (
      <GridTableCell>
        <SortButtons
          fieldName="FULL_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Customer
        </SortButtons>
      </GridTableCell>
    ),
    [SCHOLASTIC_CUSTOMER_COLUMN.LOCATION]: (
      <GridTableCell>
        <SortButtons fieldName="LOCATION" onSort={handleSort} getIsActive={getIsSortedBy}>
          Location
        </SortButtons>
      </GridTableCell>
    ),
    [SCHOLASTIC_CUSTOMER_COLUMN.AFFILIATE]: <GridTableCell>Affiliate</GridTableCell>,
    [SCHOLASTIC_CUSTOMER_COLUMN.COACH]: <GridTableCell>Coach</GridTableCell>,
    [SCHOLASTIC_CUSTOMER_COLUMN.START_DATE]: (
      <GridTableCell>
        <SortButtons
          fieldName="VALID_FROM"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Start Date
        </SortButtons>
      </GridTableCell>
    ),
    [SCHOLASTIC_CUSTOMER_COLUMN.STATUS]: <GridTableCell>Status</GridTableCell>,
    [SCHOLASTIC_CUSTOMER_COLUMN.CUSTOM_FILTER]: <div />,
    [SCHOLASTIC_CUSTOMER_COLUMN.ACTIONS]: <div />,
  };

  return (
    <GridTableRow variant="header">
      {visibleColumns.map((col) => (
        <React.Fragment key={col}>{renderColumnsInfo[col]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { TitleRow };
